export default __webpack_public_path__ + "static/media/pickup.bf0b4660.svg";